export enum Route {
    Agent = "/agents/:agentId",
    Agents = "/agents",
    AgentsSetup = "/agents/:agentId/setup-user",
    AgentsCounts = "/agents/counts",
    AgentStates = "/agents/states",
    AnomalyEvents = "/anomalies/:anomalyId/anomaly-events",
    Anomalies = "/anomalies",
    AnomaliesTrendingPhrasesVariances = "/anomalies/:anomalyId/trending-phrases/variances",
    AnomalyTagVariances = "/anomalies/:anomalyId/tag-variances",
    Anomaly = "/anomalies/:anomalyId",
    AuthenticationParameters = "/authentication-parameters",
    BackgroundTask = "/background-tasks/:backgroundTaskId",
    BackgroundTasksTagBackfills = "/background-tasks/tag-backfills",
    BackgroundTasksSubscription = "/background-tasks/:backgroundTaskId/subscriptions",
    BackgroundTasksInteractionsExports = "/background-tasks/exports/interactions",
    BackgroundTasksReviewsExports = "/background-tasks/exports/reviews",
    Client = "/clients/:clientId",
    Contact = "/contacts/:contactId",
    Contacts = "/contacts",
    ContactsSummary = "/contacts/summary",
    InteractionDetails = "/interactions/:interactionId/details",
    InteractionMetrics = "/interactions/:interactionId/metrics",
    InteractionMetricsAvailable = "/interaction-metrics/available",
    InteractionMetricsDistributions = "/interaction-metrics/distribution",
    InteractionMetricsSummaries = "/interaction-metrics/summaries",
    InteractionsGroupSummariesFeedback = "/interactions/group-summaries/feedback",
    InteractionMessages = "/interactions/:interactionId/messages",
    InteractionMessagesWritingIssues = "/interactions/:interactionId/messages/writing-issues",
    InteractionTags = "/interactions/:interactionId/tags",
    InteractionVariablesValues = "/interactions/:interactionId/variables/values",
    Interactions = "/interactions",
    InteractionsAggregates = "/interactions/aggregates",
    InteractionAudio = "/interactions/:interactionId/recordings/link",
    InteractionsCounts = "/interactions/counts",
    InteractionsMessage = "/interactions/messages/:interactionMessageId",
    InteractionsMessageTag = "/interactions/messages/:interactionMessageId/tags/:tagId",
    InteractionsMessageTags = "/interactions/:interactionId/messages/:interactionMessageId/tags",
    InteractionsMessages = "/interactions/messages",
    InteractionsMessagesCounts = "/interactions/messages/counts",
    InteractionMessageSentiments = "/interactions/:interactionId/messages/:messageId/sentiments",
    InteractionMessageSentimentUpdates = "/interactions/:interactionId/messages/:messageId/sentiments/updates",
    InteractionSummary = "/interactions/:interactionId/summaries",
    InteractionsGroupSummary = "/interactions/group-summaries",
    InteractionsGroupSummaryExamples = "/interactions/group-summaries/examples",
    InteractionAgents = "/interactions/:interactionId/agents",
    InteractionAgentPerformanceSummaries = "/interactions/:interactionId/agent-performance-summaries",
    Languages = "/languages",
    MetabaseDashboards = "/metabase-dashboards",
    MetabaseDashboardSettings = "/metabase-dashboards/settings",
    MetabaseTokens = "/metabase-dashboards/:metabaseDashboardId/tokens",
    MetricModelOutputs = "/models/:modelId/outputs",
    Model = "/models/:modelId",
    Models = "/models",
    SubscribedUsers = "/tags/:tagId/subscriptions",
    UnsubscribeUsers = "/tags/:tagId/subscriptions/:subscriptionId",
    UserSubscriptions = "/users/:userId/models",
    ParameterGroup = "/parameter-groups/:parameterGroupId",
    ParameterGroups = "/parameter-groups",
    Permissions = "/permissions",
    PhraseTrigger = "/phrase-triggers/:phraseTriggerId",
    PhraseTriggers = "/phrase-triggers",
    PhraseTriggersSamples = "/phrase-triggers/samples",
    PhraseTriggersResult = "/phrase-triggers/results/:phraseTriggerResultId",
    PhraseTriggersResults = "/phrase-triggers/results",
    PhraseTriggersCounts = "/phrase-triggers/results/counts",
    QueryParametersPreset = "/query-parameters/presets/:presetId",
    QueryParametersPresets = "/query-parameters/presets",
    QueryParametersSnapshot = "/query-parameters/snapshots/:snapshotId",
    QueryParametersSnapshots = "/query-parameters/snapshots",
    Role = "/roles/:roleId",
    Roles = "/roles",
    RolePermission = "/roles/:roleId/permissions/:permissionId",
    RolePermissions = "/roles/:roleId/permissions",
    SpellingExemption = "/spelling-exemptions/:spellingExemptionId",
    SpellingExemptions = "/spelling-exemptions",
    Tag = "/tags/:tagId",
    AiTag = "/ai-tags/:tagId",
    AiTagChangelog = "/ai-tags/:tagId/changelog",
    Tags = "/tags",
    InteractionsTagsCounts = "/interactions/tags/counts",
    TagsAgents = "/tags/:tagId/agents",
    TagGroup = "/tag-groups/:tagGroupId",
    TagGroups = "/tag-groups",
    TagGroupInteractionsVariances = "/tag-groups/:tagGroupId/interactions/variances",
    Team = "/teams/:teamId",
    Teams = "/teams",
    TeamsBrands = "/teams/brands",
    TimeZones = "/time-zones",
    Tokens = "/tokens",
    TokensRefresh = "/tokens/refresh",
    Translations = "/translations",
    User = "/users/:userId",
    UserInvite = "/users/:userId/invites",
    UserAgents = "/users/:userId/agents",
    UserSubscribe = "/users/:userId/models",
    UserUnsubscribe = "/users/:userId/models/:modelId",
    Users = "/users",
    UsersMe = "/users/me",
    UsersClients = "/users/me/clients",
    WritingIssues = "/writing-issues",
    WritingIssuesCounts = "/writing-issues/counts",
    InteractionsAnalytics = "/interactions/analytics",
    InteractionsAnalyticsCsv = "/interactions/analytics/csv",
    InteractionsAnalyticsMetrics = "/interactions/analytics/metrics",
    InteractionsAnalyticsVolume = "/interactions/analytics/volume",
    InteractionsAnalyticsTagChanges = "/interactions/analytics/tag-changes",
    Scorecards = "/scorecards",
    ScorecardsAnalytics = "/scorecards/analytics",
    ScorecardConfiguration = "/scorecards/:scorecardId",
    ScorecardQuestions = "/scorecards/:scorecardId/questions",
    ScorecardStatus = "/scorecards/:scorecardId/status",
    ScorecardEvaluations = "/scorecard-evaluations",
    ScorecardEvaluation = "/scorecard-evaluations/:scorecardEvaluationId",
    ScorecardEvaluationExists = "/scorecard-evaluations/exists",
    ScorecardEvaluationsQuestionsAnalytics = "/scorecards/:scorecardId/evaluations/questions/analytics",
    ScorecardEvaluationsQuestionsAnalyticsAggregates = "/scorecards/:scorecardId/evaluations/questions/analytics/aggregates",
    ScorecardEvaluationNotifications = "/scorecard-evaluations/:scorecardEvaluationId/notifications",
    ScorecardEvaluationRevisionRequests = "/scorecard-evaluations/:scorecardEvaluationId/revision-requests",
    ScorecardQuestion = "/scorecards/questions/:scorecardQuestionId",
    ScorecardVersions = "/scorecards/:scorecardId/versions",
    ScorecardViewed = "/scorecard-evaluations/:scorecardEvaluationId/viewed",

    // AI Chat
    AIConversations = "/ai-chat/conversations",
    AIConversation = "/ai-chat/conversations/:conversationId",
    AIConversationMessages = "/ai-chat/conversations/:conversationId/messages",
}
